import { RaffleImages } from "../raffle/images";
import { Box, Divider, Fade, Grid, Stack, Typography } from "@mui/material";
import RaffleTickets from "../raffle/tickets";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { useIsMobileView } from "../../utils/responsive";
import { hasSelectableNumbers } from "../../utils/raffleType";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import TopPurchasers from "../raffle/topPurchasersPublic";
import { useGetTopPurchasersQuery } from "../../store/api";
import { getThemeByAccountId } from "../../utils/styleConstants";
import TicketsFinder from "../ticketsFinder";
import { useEffect, useState } from "react";
import { ITopPurchaser } from "../../store/interfaces/ITopPurchaser";
import CountdownTimer from "../common/Countdown";
import ProgressBar from "../common/ProgressBar";
import RifasTrebolInfo from "../information/RifasTrebol";
import JGRInfo from "../information/JGRInfo";
import Conalot1 from '../../assets/images/conalot/conalot1.png'
import Conalot2 from '../../assets/images/conalot/conalot2.jepg.jpeg'
import Conalot3 from '../../assets/images/conalot/conalot3.jpg'
import AltaGama from '../../assets/images/accounts/altagama.png'
import PrestameAlfredo from '../../assets/images/accounts/prestamealfredo.png'
import Ogbetua from '../../assets/images/accounts/ogbetua.png'
import GanaConSalazarInfo from "../information/GanaConSalazarInfo";
import { PreviewRaffleImages } from "../raffle/preview-images";
import BendecidosConVillaInfo from "../information/BendecidosConVilla";
import MonoLokuraInfo from "../information/MonoLokuraInfo";
import FsmRifasInfo from "../information/FsmRifasInfo";
import InfoCard from "../information/FlowExoticoInfo";

interface ActiveRaffleProps {
  activeRaffle: IRaffle;
  isPreview?: boolean;
}

export const ActiveRaffle = ({ activeRaffle, isPreview }: ActiveRaffleProps) => {

  const isMobile = useIsMobileView();
  const accountInformation = useAppSelector(({ account }: RootState) => account);
  const [scrolled, setScrolled] = useState(false);


  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Grid container sx={{ background: getThemeByAccountId(accountInformation.id) === 'dark' ? '#000 !important' : '#FFF !important' }}>
      <Grid item xs={12} xl={12} lg={12} md={12} sm={12} padding={isPreview ? 0 : isMobile ? 0 : 2}>
        {
          activeRaffle.launchDate && <Grid p={4}> <CountdownTimer targetEpoch={activeRaffle.launchDate}></CountdownTimer> </Grid>
        }
          <Fade in={scrolled}>
            <Grid
            container
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: getThemeByAccountId(accountInformation.id) === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
              
              color: '#fff',
              padding: '10px',
              zIndex: 10,
              textAlign: 'center',
            }}
          >
            <Grid xs={3} xl={3} lg={3} md={3} sm={3}>
              <img
                src={accountInformation.logo}
                width={isPreview ? 60 : 120}
                height={isPreview ? 60 : 120}
                style={{ borderRadius: 20, position: 'absolute', left: 20 }}
                alt="Logo"
              />
            </Grid>
            <Grid xs={8} xl={8} lg={8} md={8} sm={8}>
              <Typography paddingLeft={2} variant="h6" fontWeight="bold" fontFamily={"Phrastic"} 
              textTransform={"uppercase"} >
                {accountInformation.name}
              </Typography>
              {activeRaffle.accountId === 'gana-con-carlasha' && (
                <>
                  <Typography paddingLeft={2} variant="body1" sx={{ fontFamily: 'Poppins' }}>
                    Gana con
                  </Typography>
                  <Typography paddingLeft={2} variant="body1" sx={{ fontFamily: 'Dancing Script' }}>
                    C
                  </Typography>
                  <Typography paddingLeft={2} variant="body1" sx={{ fontFamily: 'Poppins' }}>
                    arlasha
                  </Typography>
                </>
              )}
              {activeRaffle.accountId !== 'gana-con-carlasha' && <Typography paddingLeft={2} variant="body1" fontFamily={"Phrastic"}>
                {activeRaffle.name}
              </Typography>}
              
            </Grid>
          </Grid>
          </Fade>
        
        <Grid pb={2}>
          {isPreview ? <PreviewRaffleImages images={activeRaffle.awards.flatMap(element => element.images)}></PreviewRaffleImages> : <RaffleImages images={activeRaffle.awards.flatMap(element => element.images)}></RaffleImages>}
          
        </Grid>

        <Grid container  xs={12} xl={12} lg={12} md={12} sm={12} padding={isMobile ? 0 : 1}>
            {getThemeByAccountId(accountInformation.id) === 'dark' ? <Grid 
            item 
            xl={12} lg={12} md={12} xs={12} sm={12} 
            display={"flex"} 
            justifyContent={"center"}
            sx={{
              position: "relative",
            }}
            paddingBottom={2}
          >
            <Typography 
              variant="h4" 
              textAlign={"center"} 
              fontFamily={activeRaffle.accountId === 'sobre-ruedas-ok' ? "Impact" : "Phrastic"} 
              fontWeight={"bold"} 
              textTransform={"uppercase"} 
              paddingX={2}
              sx={{
                position: "absolute", 
                top: "-60px",
                zIndex: 2,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {activeRaffle.name}
            </Typography>
          </Grid> :  
          <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
            <Typography variant="h4" textAlign={"center"} fontFamily={"Phrastic"} fontWeight={"bold"} textTransform={"uppercase"} paddingX={2}>
            {activeRaffle.accountId === 'gana-con-carlasha' && (
              <>
                <Typography paddingLeft={2} variant="h4" fontFamily={"Phrastic"}>
                  Gana con
                </Typography>

                <Typography paddingLeft={2} variant="h4">
                  <Box component="span" sx={{ fontFamily: 'Kapakana', fontWeight: 'bold', fontSize: '40px', textTransform: 'capitalize' }}>
                    Carlasha
                  </Box>
                </Typography>
              </>
            )}

              {activeRaffle.accountId !== 'gana-con-carlasha' && <Typography paddingLeft={2} variant="body1" fontFamily={"Phrastic"}>
                {activeRaffle.name}
              </Typography>}
            </Typography>
          </Grid> }
          </Grid>

  

        {/* {accountInformation.id === 'erick-gomez' && <Box mt={6}>
          <ProgressBar raffleId={activeRaffle.id} type="bar"></ProgressBar>
        </Box> } */}
        {accountInformation.id === 'grita-caracas' && <Box mt={6}>
          <ProgressBar raffleId={activeRaffle.id} type="bar"></ProgressBar>
        </Box> }
        {accountInformation.id === 'rifas-23' && <Box mt={6}>
          <ProgressBar raffleId={activeRaffle.id} type="bar"></ProgressBar>
        </Box> }
        {/* { accountInformation.id === 'mono-lokura' &&  <MonoLokuraInfo></MonoLokuraInfo> } */}
        {/* { accountInformation.id === 'rifas-trebol' && <RifasTrebolInfo></RifasTrebolInfo> } */}
        {/* { accountInformation.id === 'bendecidos-con-villa' && <BendecidosConVillaInfo></BendecidosConVillaInfo> } */}
        { accountInformation.id === 'flow-exotico' && <InfoCard items={
            [
                { label: '30.000 KM' },
                { label: 'Compra mínima: 5 tickets' },
                { label: 'Lotería: SUPER GANA' },
                { label: '¡PARTICIPA Y GANA!', highlight: true },
              ]
        }></InfoCard> }
        { accountInformation.id === 'rifas-kevingal' && <InfoCard items={
            [
                { label: 'Extras' },
                { label: 'Participa de 2 tiket en adelante' },
                { label: 'Segundo y tercer lugar 150$' },
                { label: '5 tiket premios valiendo 50$ c/u' },
              ]
        }></InfoCard> }
        { accountInformation.id === 'rifas-el-charro' && <InfoCard items={
            [
                { label: 'GÁNATE $3,000 o $4,000! 🎉', highlight: true },
                { label: '¡Todo depende de ti! Aprovecha nuestra promo especial:' },
                { label: '💥 Si compras 10 números o más y resultas ser el feliz ganador, te llevas $4,000 en lugar de $3,000. ¡Así de fácil!' },
                { label: '🎟️ Los tickets premiados serán pagados a $100, pero si llevas 10 numeritos en adelante, se te cancelan en $200 💵.' },
                { label: '📅 La fecha de la rifa será anunciada una vez que lleguemos al 70% de los números vendidos.' },
                { label: '📲 Te estaré informando por Instagram, ¡así que mantente pendiente!' },
                { label: 'El precio del ticket es 1.5$', highlight: true },
                { label: '🎟️ 5 Tickets Premiados', highlight: false, winningNumbers: ['2184', '4321', '5422', '7225', '9663']},
                { label: 'Lotería: SUPER GANA', highlight: true },
              ]
        }></InfoCard> }
        { accountInformation.id === 'gerej-16' && <InfoCard items={
            [
              { label: 'Transformando tus anhelos en una realidad 🚀☘️', highlight: true },
            ]
        }></InfoCard> }
        { accountInformation.id === 'rifas-petare' && <InfoCard items={
            [
                { label: '1. Solo pueden participar personas naturales mayores de 18 años.' },
                { label: '2. Los premios se entregarán personalmente en el lugar designado para cada sorteo. ' },
                { label: '3. La compra mínima es de (1) tickets. Los tickets se asignarán aleatoriamente y se enviarán al correo electrónico que nos proporciones' },
                { label: '4. Los ganadores tienen 72 horas para reclamar su premio.' },
                { label: '5. Los ganadores aceptan y autorizan la aparición en el material audiovisual del sorteo de Rifas Petare, incluyendo su presencia en redes sociales y la entrega del premio. Esta condición es obligatoria.' },
                { label: '6. Debe transferir el monto exacto, no se realizan reembolsos por montos erroneos, de haber una diferencia se realizara el reembolso solamente con tickets.' },
              ]
        }></InfoCard> }
        
        
       
       
        { accountInformation.id === 'el-de-la-h' && <InfoCard items={
            [
              
                { label: 'Merú 2007 + Efectivo💸 (Si compras más de 10 tickets y eres el afortunado ganador, se duplica el premio en efectivo)' },
                { label: '2do lugar: 1000💸 (Número ganador invertido)' },
                { label: '3er lugar: 500💸 (El que le sigue al número ganador)' },
                { label: '4to lugar 500💸 (El anterior al número ganador)' },
              ]
        }></InfoCard> }
   
            
        { accountInformation.id === '2-locos-rifando' && <InfoCard items={
            [
                { label: '1er 2000$' },
                { label: '2do premio 300$' },
                { label: '3er lugar 300$' },
                { label: 'Top de compra 400$', highlight: true },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'rifas-23' && <InfoCard items={
            [
                { label: 'El sorteo se realizará a través de la Lotería Real – Pega 4, en el sorteo de la 1:00 p.m.' },
                { label: 'La fecha oficial del sorteo es el 30 de enero.' },
                { label: 'No obstante, si la venta total de los boletos se completa antes de esa fecha, el sorteo podrá adelantarse. En caso contrario, podrá posponerse, de acuerdo con las normativas establecidas por Pro Consumidor.' },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'yoiber-mota' && <InfoCard items={
            [
                { label: 'La compra mínima es de (2) tickets. Los tickets se asignarán aleatoriamente y se enviarán al correo electrónico que nos proporciones' },
              ]
        }></InfoCard> }

        { accountInformation.id === 'rifas-el-largo' && <InfoCard items={
            [
                { label: 'Compra mínima: 2 tickets' },
                { label: 'El sorteo se relizara al finalizar la venta de los números' },
                { label: 'Lotería: Triple Táchira A 10:10pm' },
                { label: '¡PARTICIPA Y GANA!', highlight: true },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'carlos-pinango' && <InfoCard items={
            [
                { label: 'Premio mayor 5000$ en efectivo' },
                { label: '1:00pm 500$ trasferencia' },
                { label: '4:00pm trasferencia inmediata' },
                { label: 'Top de compra 2000$ en efectivo' },
                { label: 'Valor 350 bs de 1 ticke en adelante' },
            ]
        }></InfoCard> }
        { accountInformation.id === 'el-gran-perrote' && <InfoCard items={
            [
                { label: 'Lotería: Medellín' },
              ]
        }></InfoCard> }

        {
          accountInformation.id === 'rifas--jr' && <InfoCard items={
            [
                { label: 'Llegó tu momento esperado' },
                { label: '1* premio participa por la Toyota runner' },
                { label: 'Valor del boleto 6 mil pesos' },
                { label: '2* premio kia Morning' },
                { label: 'Para participar por los 2 premios la compra mínima debe ser de 4 boletos , de lo contrario estarías solo participando por la Toyota runner' },
                { label: '✨no esperes más asegura tu compra y espera mi llamada es tu momento ✨' },
                { label: '📅 fecha del sorteo :' },
                { label: 'Con el 80% vendidos anunciamos fecha del sorteo' },
              ]
        }></InfoCard> }
        { accountInformation.id === 'rifas-la-botija' && <InfoCard items={
            [
                { label: 'POR SOLO $3 GANA $10.000 EN EFECTIVO PERO SI ASEGURAS MAS DE 20 TICKES TE LLEVAS $15.000' },
                { label: 'ESTAMOS EN GUARENAS, URB LOS NARANJOS, LICORERÍA LA BOTIJA DEL NARANJERO' },
                { label: 'ESTO JUEGA POR LA LOTERÍA DEL TACHIRA, SORTEÓ SÚPER GANA 10PM' },
                { label: '¡PARTICIPA Y GANA!', highlight: true },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'tu-gran-sueno' && <InfoCard items={
            [
                { label: 'New Outlook 2025' },
                { label: 'Rk 2025 + IPhone 16 Pro Max ' },
                { label: 'La persona que más tickets compre se llevará una moto Brf 2025 OKM' },
                { label: 'La afortunada persona con el número 7777 se le entregará Milán 2025 totalmente a estrenare', highlight: true },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'rifas-los-chacaros' && <InfoCard items={
            [
                { label: '🚀 ¡KLR 650 x $2! ' },
                { label: 'Llévala a Precio de Perro Caliente 🌭' },
                { label: '¡Tu Aventura Empieza Aquí.' },
                { label: 'No es broma. Participa en la rifa de la Kawasaki KLR 650 2014 por solo 2 Dólares.' },
              ]
        }></InfoCard> }
        
        { accountInformation.id === 'fsm-rifas' && <FsmRifasInfo></FsmRifasInfo> }
        { accountInformation.id === 'jgr1' && <JGRInfo></JGRInfo>}
        { accountInformation.id === 'gana-con-salazar' && <GanaConSalazarInfo></GanaConSalazarInfo>}
        <Grid>
          {activeRaffle.type !== 'promo'  &&  
          (accountInformation.id == 'carlos-pinango' || 
          accountInformation.id == 'gn-rifas' || 
          accountInformation.id == 'rifas-chente' || 
          accountInformation.id == 'anthony-flow' || 
          accountInformation.id == 'la-barberia' || 
          accountInformation.id == 'lobo-guarenas' || 
          accountInformation.id == 'maikel-jaimez' || 
          accountInformation.id == 'minas-de-baruta' || 
          accountInformation.id == 'diego-merchan' ||  
          accountInformation.id == 'erick-gomez' ||  
          accountInformation.id == 'sobre-ruedas-ok' || 
          accountInformation.id == 'brotherifas' || 
          accountInformation.id == 'dj-tito') &&
          <TopPurchasers raffleId={activeRaffle.id}></TopPurchasers>}
        </Grid>


        {!hasSelectableNumbers(activeRaffle.type) && <Grid sx={{ p: 4, pt: 0 }} pt={4}>
          <Typography variant="h6" fontWeight={"bold"} textAlign={"center"}>¿Cuantos tickets {activeRaffle.accountId == 'sobre-ruedas-ok' ? 'querés?': 'quieres?'}</Typography>
        </Grid>}
        <Grid item  xs={12} xl={12} lg={12} sm={12}>
            <RaffleTickets accountId={accountInformation.id} raffleId={activeRaffle.id} limit={activeRaffle.limit} ticketPriceUSD={activeRaffle.ticketPriceUSD} ticketPrice={activeRaffle.ticketPrice} availablePaymentMethods={activeRaffle.availablePaymentMethods} raffleType={activeRaffle.type} /> 
        </Grid>

            { accountInformation.id !== 'oscar-alarcon' 
              && accountInformation.id !== 'motor-luck' 
              && accountInformation.id !== 'zpremio' 
              && 
              <>
              <Divider></Divider>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Typography variant="h6" fontWeight={"bold"} textAlign={"center"}>{activeRaffle.accountId == 'sobre-ruedas-ok' ? 'Querés': 'Quieres'} verificar tus tickets? <br/> Ingresa el correo aquí:</Typography>
                <TicketsFinder isPublic={false} raffleId={activeRaffle.id} activeRaffleName={activeRaffle.name} limit={activeRaffle.limit} />
              </Grid>
              <Divider></Divider>
              </>
            }
            
            {activeRaffle.type === 'raffle' 
              && (accountInformation.id === 'w-robles' 
              || accountInformation.id === 'tus-rifas-rt')
              && 
              <>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Stack justifyContent={"space-around"} direction={"row"} spacing={2}>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot1} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot2} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot3} alt="Ganadores" width={80} />
                  </Box>
                </Stack>
              </Grid>
              <Divider></Divider>
              </>
            }
            {accountInformation.id === 'la-buena-racha' && <>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Stack justifyContent={"space-around"} direction={"row"} spacing={2}>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot1} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot2} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot3} alt="Ganadores" width={80} />
                  </Box>
                </Stack>
              </Grid>
              <Divider></Divider>
              </>
            }
            {accountInformation.id === 'alta-gama' && <>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Stack justifyContent={"space-around"} direction={"row"} spacing={2}>
                  <Box sx={{ borderRadius: 2, border: '1px solid #ccc', padding: 1 }} onClick={() => window.open('https://www.instagram.com/altagama18k', '_blank')}>
                    <img src={AltaGama} alt="Ganadores" width={80} />
                    <Typography variant="body2" fontWeight="bold" textAlign="center">Alta Gama 18K</Typography>
                  </Box>
                  <Box sx={{ borderRadius: 2, border: '1px solid #ccc', padding: 1 }} onClick={() => window.open('https://www.instagram.com/alfredobastardo1994', '_blank')}>
                    <img src={PrestameAlfredo} alt="Ganadores" width={80} />
                    <Typography variant="body2" fontWeight="bold" textAlign="center">Prestame Alfredo</Typography>
                  </Box>
                  <Box sx={{ borderRadius: 2, border: '1px solid #ccc', padding: 1 }} onClick={() => window.open('https://www.instagram.com/joyas_ogbetua.cl', '_blank')}>
                    <img src={Ogbetua} alt="Ganadores" width={80} />
                    <Typography variant="body2" fontWeight="bold" textAlign="center">Ogbetua</Typography>
                  </Box>
                </Stack>
              </Grid>
              <Divider></Divider>
              </>
            }
      </Grid>
    </Grid>
  );
};
